var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('simple-dialog',{attrs:{"title":"表示設定","value":_vm.value},on:{"input":function($event){_vm.$emit('input', $event)}}},[_c('messages-limit-input',{attrs:{"value":_vm.messagesLimit},on:{"input":_vm.updateMessagesLimit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }